export default __webpack_public_path__ + "static/media/close.b057f2af.svg";